import React from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function SimpleTable({ columns, rows }) {
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.key || column.field || column.label}>
                {column.label || column.title || column.key || column.field}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.length > 0 ? (
            rows.map((row, rowIndex) => (
              <TableRow key={row.id || rowIndex}>
                {columns.map((column) => {
                  const key = column.key || column.field || column.accessor || "";
                  const value =
                    typeof column.render === "function" ? column.render(row, rowIndex) : row[key];

                  return (
                    <TableCell key={`${row.id || rowIndex}-${key || column.label}`}>
                      {value ?? "-"}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length || 1} align="center">
                <Typography variant="body2" color="text.secondary">
                  No records found
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SimpleTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
};

SimpleTable.defaultProps = {
  columns: [],
  rows: [],
};
